import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import user from './modules/user';
import recommandations from './modules/recommandations';
import pointDeVente from './creationRecommandation/pointDeVente';
import client from './modules/client';
import contacts from './modules/contacts';
import parametrage from './modules/parametrage';
import societe  from './modules/societe';
import * as types from './mutation-type';

Vue.use(Vuex);

function dateTimeReviver(key, value) {
  let resultRegex;
  if (typeof value === 'string') {
    resultRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/.exec(value);
    if (resultRegex) {
      return new Date(value);
    }
  }
  return value;
}

const modules = {
  user,
  recommandations,
  pointDeVente,
  client,
  contacts,
  parametrage,
  societe,
};

const store = new Vuex.Store({
  modules: modules,
  plugins: [createPersistedState({
    key: 'aa_project',
    getState(key, storage) {
      try {
        const localValue = storage.getItem(key);
        let state;
        if (localValue !== 'undefined') {
          state = JSON.parse(localValue, dateTimeReviver);
        }
        return state;
      } catch (err) {
        /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      }

      return undefined;
    },
    paths: [
      'user',
      'recommandations.devis',
      'recommandations.produitsLocation',
      'recommandations.panneauxSousContrat',
      'pointDeVente.concurrentSelectionnes',
      'parametrage',
      'societe',
    ],
  })],
});

export default store;

export function resetState() {
  Object.keys(store._modules.root._children).forEach((module) => {
    store.commit(module + '/' + types.RESET_STATE);
  });
}
